import { Component, OnInit, Inject } from '@angular/core';
import { VERSION, MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'bil-mao-modal',
  templateUrl: './mao-modal.component.html',
  styleUrls: ['./mao-modal.component.sass']
})
export class MaoModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<MaoModalComponent>) {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}
